import useLanguage from '@op/hooks/useLanguage';
import React, { useMemo } from 'react';
import { Table } from 'tea-component';
import { scrollable } from 'tea-component/lib/table/addons';
import { columnsList } from '../../utils';

export default function DurationTable({
  height,
  records,
}: {
  height: number;
  records: Array<any>;
}) {
  const { formatMessage } = useLanguage();

  const tableColumns = useMemo(() => {
    return columnsList.map(
      ({
        header,
        tableHeader,
        key,
        width,
        align = 'right',
        format,
        icon,
      }: any) => {
        return {
          key,
          align,
          width,
          header: (
            <>
              {icon && (
                <img style={{ width: 20, marginRight: 5, verticalAlign: 'middle'}} src={icon}></img>
              )}
              {formatMessage({ id: tableHeader || header })}
            </>
          ),
          render: (data: any) => {
            const value = data[key];
            return format ? format(value) : value;
          },
        };
      },
    );
  }, [formatMessage]);

  return (
    <Table
      columns={tableColumns}
      recordKey={'key'}
      records={records}
      addons={[
        scrollable({
          maxHeight: height,
          minWidth: 900,
        }),
      ]}
    ></Table>
  );
}
